import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || '';

// CONTROL DE ENTREGA DE PREMIOS (link sin cuenta).
//
// Lo abre quien entrega, desde su teléfono. Ve solo lo que necesita: el nombre de la
// persona, el premio y el código. Sin emails, sin teléfonos y sin puntos: este link se
// pasa por WhatsApp y termina en cualquier equipo.
//
// Pensado para la barra: primero el buscador (la persona dice su código) y un botón
// grande por fila. Los cupones aparecen aparte, porque no se entregan.
export default function PremiosControl() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [estado, setEstado] = useState('pendientes');
  const [q, setQ] = useState('');
  const [err, setErr] = useState('');
  const [marcando, setMarcando] = useState(null);

  const cargar = useCallback(() => {
    fetch(`${API}/api/public/premios/${token}?estado=${estado}&q=${encodeURIComponent(q)}`)
      .then(r => r.ok ? r.json() : r.json().then(d => Promise.reject(d)))
      .then(d => { setData(d); setErr(''); })
      .catch(d => setErr(d?.error || 'No se pudo cargar'));
  }, [token, estado, q]);
  useEffect(() => { const t = setTimeout(cargar, q ? 300 : 0); return () => clearTimeout(t); }, [cargar, q]);

  // Refresco cada 30 s: el que entrega deja la pantalla abierta toda la noche y los canjes
  // entran mientras tanto. Mientras está buscando no se refresca, para no moverle la lista
  // justo cuando encontró el código.
  useEffect(() => {
    if (q) return undefined;
    const t = setInterval(cargar, 30000);
    return () => clearInterval(t);
  }, [cargar, q]);

  async function entregar(c) {
    setMarcando(c.id);
    try {
      const r = await fetch(`${API}/api/public/premios/${token}/entregar/${c.id}`, { method: 'POST' });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) alert(d.error || 'No se pudo marcar');
      cargar();
    } finally { setMarcando(null); }
  }

  const fmt = (d) => { try { return new Date(d).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'America/Argentina/Buenos_Aires' }); } catch { return ''; } };

  if (err && !data) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'grid', placeItems: 'center', padding: 20 }}>
        <div className="lb-card" style={{ padding: '28px 26px', textAlign: 'center', maxWidth: 360 }}>
          <div className="lb-h" style={{ fontSize: 18 }}>{err}</div>
          <p style={{ color: 'var(--ink-600)', fontSize: 13, marginTop: 8 }}>Pedile al boliche un link nuevo.</p>
        </div>
      </div>
    );
  }
  if (!data) return <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'grid', placeItems: 'center', color: 'var(--ink-600)' }}>Cargando…</div>;

  const canjes = data.canjes || [];

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '24px 16px 60px' }}>
      <div style={{ maxWidth: 620, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          {data.logo_url && <img src={data.logo_url} alt="" style={{ height: 34, marginBottom: 8 }} />}
          <div className="lb-eyebrow">Entrega de premios</div>
          <div className="lb-h" style={{ fontSize: 20, marginTop: 4 }}>{data.puesto}</div>
          <div style={{ fontSize: 12.5, color: 'var(--ink-600)', marginTop: 6 }}>
            {data.pendientes > 0
              ? <><b style={{ color: '#fff' }}>{data.pendientes}</b> {data.pendientes === 1 ? 'premio pendiente' : 'premios pendientes'} de entrega</>
              : 'No hay premios pendientes ✓'}
          </div>
        </div>

        <input className="lb-input" style={{ marginBottom: 12 }} inputMode="numeric"
          placeholder="Buscar por código o premio" value={q} onChange={e => setQ(e.target.value)} />

        <div style={{ display: 'flex', gap: 6, marginBottom: 14 }}>
          {[['pendientes', 'Pendientes'], ['entregados', 'Entregados'], ['todos', 'Todos']].map(([k, l]) => (
            <button key={k} onClick={() => setEstado(k)} style={{ flex: 1 }}
              className={'lb-btn lb-btn--sm ' + (estado === k ? 'lb-btn--white' : 'lb-btn--ghost')}>{l}</button>
          ))}
        </div>

        {canjes.length === 0 && (
          <div className="lb-card" style={{ padding: '26px 22px', textAlign: 'center', color: 'var(--ink-600)', fontSize: 13 }}>
            {q ? 'No encontramos ese código.' : estado === 'pendientes' ? 'Todo entregado por ahora ✓' : 'Sin canjes.'}
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {canjes.map(c => {
            const cupon = c.tipo === 'cupon';
            return (
              <div key={c.id} className="lb-card" style={{ padding: '16px 18px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ color: '#fff', fontWeight: 600 }}>{c.premio}</div>
                    <div style={{ fontSize: 13, color: 'var(--ink-800)', marginTop: 2 }}>{c.persona}</div>
                    <div style={{ fontSize: 11.5, color: 'var(--ink-600)', marginTop: 4 }}>
                      {cupon ? '🎟️ Cupón · se usa al comprar' : `📦 ${c.retiro || 'Retiro en el boliche'}`} · {fmt(c.fecha)}
                    </div>
                  </div>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22, color: 'var(--red-400)', letterSpacing: '0.06em' }}>{c.codigo}</div>
                </div>
                {!cupon && (
                  c.entregado_at
                    ? <div style={{ marginTop: 12, fontSize: 12.5, color: '#2ecc71' }}>✓ Entregado {c.entregado_por ? `por ${c.entregado_por}` : ''} · {fmt(c.entregado_at)}</div>
                    : <button className="lb-btn lb-btn--primary lb-btn--block" style={{ marginTop: 12 }}
                        disabled={marcando === c.id} onClick={() => entregar(c)}>
                        {marcando === c.id ? 'Marcando…' : 'Marcar entregado'}
                      </button>
                )}
                {cupon && <div style={{ marginTop: 10, fontSize: 11.5, color: 'var(--ink-600)' }}>No hay nada que entregar: el descuento se aplica solo al comprar.</div>}
              </div>
            );
          })}
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: 'var(--ink-600)' }}>
          {data.org_name} · La lista se actualiza sola cada 30 segundos.
        </div>
      </div>
    </div>
  );
}
